import { bodyMedium } from '@monorepo/shared/styles/text';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  background-color: ${({ theme }) => theme.colors.grayf4};
`;

const TitleGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const Title = styled.span`
  ${bodyMedium}
  color: ${({ theme }) => theme.colors.gray333};
`;

interface MenuPanelHeaderProps {
  /** Control rendered at the end of the bar, e.g. a Reset button. */
  action?: ReactNode;
  /** Control rendered before the title, e.g. a back button. */
  children?: ReactNode;
  title: string;
}

export function MenuPanelHeader({
  action,
  children,
  title,
}: MenuPanelHeaderProps) {
  return (
    <HeaderContainer>
      <TitleGroup>
        {children}
        <Title>{title}</Title>
      </TitleGroup>
      {action}
    </HeaderContainer>
  );
}
